import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API_URL =
  process.env.REACT_APP_API_URL || 'https://snaplet.onrender.com/api';

function SharedFile() {
  const { token } = useParams();
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchFile = async () => {
      try {
        const res = await fetch(`${API_URL}/files/share/${token}`);

        if (!res.ok) {
          throw new Error('Invalid or expired link');
        }

        const data = await res.json();
        setFile(data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchFile();
  }, [token]);

  if (error) {
    return <p style={{ textAlign: 'center' }}>{error}</p>;
  }

  if (!file) {
    return <p style={{ textAlign: 'center' }}>Loading…</p>;
  }

  const { file_url, file_type, file_name } = file;

  return (
    <div style={{ padding: 16 }}>
      <h3>{file_name}</h3>

      {file_type.startsWith('image/') ? (
        <img
          src={file_url}
          alt={file_name}
          style={{ maxWidth: '100%' }}
        />
      ) : file_type === 'application/pdf' ? (
        <iframe
          src={file_url}
          title={file_name}
          style={{ width: '100%', height: '90vh' }}
        />
      ) : (
        <a href={file_url} target="_blank" rel="noreferrer">
          Download file
        </a>
      )}
    </div>
  );
}

export default SharedFile;
